import type { useSortable } from '@dnd-kit/sortable'
import { DragHandle } from '@features/shared/components/DragHandle'

type SortableReturn = ReturnType<typeof useSortable>

/**
 * A row's icon, while the row's drag handle can take its place: hidden while
 * the row is hovered or holds keyboard focus, when LeadingDragHandle shows.
 * Keyboard focus only (`:focus-visible`): the handle keeps focus after a mouse
 * drag (dnd-kit gives it back on the drop), and that mustn't leave it showing.
 */
export const DRAG_SWAPPED_ICON_CLASS = 'group-hover:invisible group-has-[:focus-visible]:invisible'

/**
 * A sidebar row's drag handle in its icon's place (`left` and `size` are the
 * icon's): hidden at rest, it shows over the icon while the row is hovered or
 * holds keyboard focus, and the row hides its icon meanwhile
 * (DRAG_SWAPPED_ICON_CLASS), so the handle adds no width and the name never
 * moves. The row must be the `group`, and positioned.
 */
export function LeadingDragHandle({
  left,
  size,
  listeners,
  attributes,
  disabled,
  disabledReason,
}: {
  left: number
  size: number
  listeners?: SortableReturn['listeners']
  attributes?: SortableReturn['attributes']
  disabled?: boolean
  disabledReason?: string
}) {
  return (
    <span
      // Above the row's link; takes the pointer only while it shows.
      className="pointer-events-none absolute inset-y-0 z-10 flex items-center justify-center opacity-0 group-hover:pointer-events-auto group-hover:opacity-100 group-has-[:focus-visible]:pointer-events-auto group-has-[:focus-visible]:opacity-100"
      style={{ left, width: size }}
      onClick={(event) => event.stopPropagation()}
    >
      <DragHandle
        listeners={listeners}
        attributes={attributes}
        disabled={disabled}
        disabledReason={disabledReason}
        iconSize={size}
        className="h-6 justify-center"
      />
    </span>
  )
}
